import React from 'react'
import { GlobalContext, UserContext } from 'components/context'
import { Link } from 'react-router-dom'
import { featureEnabled } from 'components/features'

const AccessInfo = () => {
  const { t, locale, env } = React.useContext(GlobalContext)
  const { membership } = React.useContext(UserContext)
  const nfcEnabled = featureEnabled('nfc', locale, env)

  if (!membership) return null

  if (!nfcEnabled) return null

  return (
    <div className={'index-info full-width'}>
      <div className={'access-info'}>
        <h3>{ t('pages.info.access_choice') }</h3>
        <ol>
          <li>
            <Link to={{ pathname: '/membership/access/nfc', search: '?action=activate' }}>
              {t('pages.info.access_nfc')}
            </Link>
          </li>
          <li>
            <Link to={{ pathname: '/membership/access/rfid', search: '?action=activate' }}>
              {t('pages.info.access_rfid')}
            </Link>
          </li>
        </ol>
      </div>
    </div>
  )
}

export default AccessInfo
